<template>
  <section>
    <div class="lm-header">
      <h2
        class="title is-5"
        v-text="$t('DashboardEDD.title').toUpperCase()"
      />
      <h3
        class="subtitle is-5"
        v-text="$t('Common.filters')"
      />
    </div>
    <filters
      options="edd"
    />
    <orders
      options="edd"
    />
  </section>
</template>

<script>
import Filters from '@/components/filters/Filters'
import Orders from '@/components/dashboard/Orders'

export default {
  name: 'DashboardEDD',
  beforeCreate () {
    this.$store.dispatch('orders/flush')
    this.$store.dispatch('filters/flush')
  },
  components: {
    Filters,
    Orders
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardEDD.vue